import { render, staticRenderFns } from "./Agreements.vue?vue&type=template&id=2a07f8e4"
import script from "./Agreements.vue?vue&type=script&lang=js"
export * from "./Agreements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports